import type { RouteRecordRaw } from 'vue-router'

const vesselReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/vessel-reports',
    name: 'vessel-reports.index',
    component: () => import('@/modules/vessel-reports/views/VesselReportsIndex.vue'),
    meta: {
      pageTitle: 'Vessel reports',
      breadcrumbs: ['Vessel reports']
    }
  }
]

export default vesselReportsRoutes
